import { Button, Card, Empty, Flex, Result, Skeleton } from 'antd';

import { isUpstreamKeyError } from '../api/backend';

export const LoadingGrid = ({ cards = 8 }: { cards?: number }) => (
    <div className='nft-grid' style={{ marginTop: 8 }}>
        {Array.from({ length: cards }, (_, index) => (
            <Card key={index} size='small' cover={<div className='nft-card-cover' />}>
                <Skeleton active paragraph={{ rows: 2 }} title={{ width: '70%' }} />
            </Card>
        ))}
    </div>
);

interface ErrorStateProps {
    message: string;
    onRetry: () => void;
}

export const ErrorState = ({ message, onRetry }: ErrorStateProps) => (
    <Result
        status='warning'
        title="Couldn't load this data"
        subTitle={
            isUpstreamKeyError(message)
                ? 'Our data source (OpenSea) is temporarily unavailable while its access key is being renewed. Please check back soon.'
                : message
        }
        extra={
            <Button type='primary' onClick={onRetry}>
                Try again
            </Button>
        }
    />
);

export const EmptyState = ({ description }: { description: string }) => (
    <Flex align='center' justify='center' style={{ minHeight: 320 }}>
        <Empty description={description} />
    </Flex>
);
